import SectionHead from "./SectionHead";
import { isOpenable } from "../actions";
import { ORGANIZATION_COPY } from "../copy";
import chevronIcon from "../../../Assets/icon/explore/chevron-right-light.svg";
import missionIcon from "../../../Assets/icon/explore/org-mission.svg";

/**
 * ORGANIZATION (Figma 9154:8266) — an entitlement surface, present only for
 * members whose organization has shared content. `display_name` names it
 * ("From Farmers Insurance").
 *
 * The items are the organization's own Dialogues — ordinary
 * UniversalDialogueCards with `context_line_kind: ORG_RECOMMENDED` — not the
 * fixed Mission / Vision / Values / Principles / Benefits rows the design
 * shows, and they carry no icon key (§7 E7). So each row takes the one
 * neutral tile rather than an icon picked per title.
 */
function OrganizationSection({ section, onOpenDialogue }) {
  const items = (section?.items || []).filter(isOpenable);
  if (items.length === 0) return null;

  const name = section?.display_name;

  return (
    <section className="ex-section">
      <SectionHead
        title={name ? `${ORGANIZATION_COPY.titlePrefix} ${name}` : ORGANIZATION_COPY.titleFallback}
        subtitle={ORGANIZATION_COPY.subtitle}
      />

      <div className="ex-org">
        {items.map((item, i) => (
          <button
            key={item.dialogue_id || i}
            type="button"
            className="ex-org__row"
            onClick={() => onOpenDialogue?.(item)}
          >
            <span className="ex-org__chip">
              <img src={missionIcon} alt="" width="16" height="16" />
            </span>
            <span className="ex-org__text">
              <span className="ex-org__title">{item.title}</span>
              {item.context_line && <span className="ex-org__desc">{item.context_line}</span>}
            </span>
            <span className="ex-org__chevron">
              <img src={chevronIcon} alt="" width="16" height="16" />
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}

export default OrganizationSection;
